const routes = {
  root: '/ces-detailed/details',
}

export default routes
